import { Component, ref } from 'vue';

class ComponentPresenter {
	public isLoading = ref(true);

	public async loadTinyMCEComponent(): Promise<Component> {
		const component = await import('@/presentation/components/internal-notes/tiny-mce/tiny-mce.vue');
		this.isLoading.value = false;
		return component;
	}
}

export default new ComponentPresenter();
